export default "__VITE_ASSET__BHK9al5v__"